import DepsService from 'services/dependencies';

const CONTEXT = 'selfRegistration';

export const fetchOwnerValidationMethod = (locale = '*') => {
  const { url } = DepsService.rest.dictionary.ownerValidationMethod;
  const queryParams = {};
  const urlParams = { locale };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const validateOwnerData = (params) => {
  const { url } = DepsService.rest.selfRegistration.validation;
  const queryParams = { ...params };
  const urlParams = {};

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

export const fetchRetailerDetails = (retailerId, captchaToken) => {
  const { url } = DepsService.rest.user.retailerSettings.selfRegistration;
  const queryParams = { captchaToken };
  const urlParams = { retailerId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const createAccount = (queryParams, urlParams) => {
  const { url } = DepsService.rest.account.primaryEntries;

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};

const transformUserData = ({
  firstName,
  lastName,
  contactPhone,
  mobilePhone,
  emailAddress,
  password,
  businessPhone,
  questionA,
  answerA,
  questionB,
  answerB,
}) => ({
  firstName,
  lastName,
  contactPhone,
  mobilePhone,
  emailAddress,
  password,
  businessPhone,
  challenges: [
    {
      questionId: questionA,
      answer: answerA,
    },
    {
      questionId: questionB,
      answer: answerB,
    },
  ],
});

export const confirmRegistration = async (userData) => {
  const { url } = DepsService.rest.account.confirmRegistration;
  const data = transformUserData(userData);

  return DepsService.restSrv.update(CONTEXT, url, data);
};

export const activateAccount = async (username, token) => {
  const { url } = DepsService.rest.selfRegistration.activation;
  const queryParams = {
    username,
    token,
  };
  const urlParams = {};

  return DepsService.restSrv.create(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/registration/resources/registration.api.js